import request from "@/utils/request";
import URL from "@/api/baseUrl";

const basePath = `${URL.vip}/workbench`;

export default class Workbench {
  static data(params = {}) {
    return request.get(`${basePath}/data`, params);
  }

  static abnormalCount(params = {}) {
    return request.get(`${basePath}/abnormal-count`, params);
  }

  static abnormalOrders(params = {}) {
    return request.get(`${basePath}/abnormal-orders`, params);
  }

  static orderTimeliness(params = {}) {
    return request.get(`${basePath}/order-timeliness`, params);
  }

  static fulfillingOrders(params = {}) {
    return request.get(`${basePath}/fulfilling-orders`, params);
  }

  static monthOrders(params = {}) {
    return request.get(`${basePath}/month-orders`, params);
  }

  static reconcilingOrders(params = {}) {
    return request.get(`${basePath}/reconciling-orders`, params);
  }
}
